import { getCommercial } from "../api/commercial";
import { PdfFileNameResponse } from "./types";
import { LanguageFrontendType } from "../pages/shared/components/language/types";
import {
  CountryDto,
  IndustryDto,
  NogaCodeDto,
  ProductsDto,
} from "../api/commercial/generated-types";
import NetworkError from "../api/http/networkError";

const loadCountries = async (
  selectedLanguage: string,
): Promise<CountryDto[]> => {
  try {
    return await getCommercial("/countries", {
      locale: selectedLanguage,
    });
  } catch {
    throw new NetworkError("Failed fetching countries");
  }
};

const loadNogaCodes = async (
  selectedLanguage: string,
): Promise<NogaCodeDto[]> => {
  try {
    return await getCommercial("/noga", {
      locale: selectedLanguage,
    });
  } catch {
    throw new NetworkError("Failed fetching noga codes");
  }
};

const loadIndustries = async (
  selectedLanguage: string,
): Promise<IndustryDto[]> => {
  try {
    return await getCommercial(`/industry`, {
      locale: selectedLanguage,
    });
  } catch {
    throw new NetworkError("Failed fetching industries");
  }
};

const loadProducts = async (): Promise<ProductsDto> => {
  try {
    return await getCommercial("/products");
  } catch {
    throw new NetworkError("Failed fetching products");
  }
};

const loadMessagesSource = async (
  selectedLanguage: LanguageFrontendType,
  prefix = "",
): Promise<Record<string, string>> => {
  const resolvedLanguage =
    Object.values(LanguageFrontendType).indexOf(selectedLanguage) === -1
      ? LanguageFrontendType.de
      : selectedLanguage;

  try {
    const response = await fetch(`/${prefix}i18n_${resolvedLanguage}.json`);
    return await response.json();
  } catch {
    throw new NetworkError(
      "Message source failed loading with given language: " + selectedLanguage,
    );
  }
};

const loadFeatureToggles = async (): Promise<Record<string, boolean>> => {
  try {
    return await getCommercial(`/feature-toggles`);
  } catch {
    throw new NetworkError("Failed fetching feature toggles");
  }
};

const getPdfFileName = async (
  applicationRef: string,
): Promise<PdfFileNameResponse> => {
  try {
    return await getCommercial(`/protected/applications/${applicationRef}`);
  } catch {
    throw new NetworkError("Failed fetching Pdf filename");
  }
};

export {
  getPdfFileName,
  loadCountries,
  loadNogaCodes,
  loadIndustries,
  loadProducts,
  loadMessagesSource,
  loadFeatureToggles,
};
